import { Link } from 'react-router-dom'
import './Intro.css'


export default function (){
    return (
        <div className="wrapper">
            <h1 className='page-title'>typing test</h1>
            <hr />
            <div className='type-select'>
                <div className="title">timed tests</div>
                <div className="types-wrapper">
                    <div className="type">
                        <p className="title">1:00 test</p>
                        <Link to={`test/1`} className="start-btn">start</Link>
                    </div>
                    <div className="type">
                        <p className="title">3:00 test</p>
                        <Link to={`test/3`} className="start-btn">start</Link>
                    </div>
                    <div className="type">
                        <p className="title">5:00 test</p>
                        <Link to={`test/5`} className="start-btn">start</Link>
                    </div>
                    <div className="type">
                        <p className="title">10:00 test</p>
                        <Link to={`test/10`} className="start-btn">start</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}